import React, { Component } from "react";
import * as d3 from "d3";
import PropTypes from "prop-types";
import "./newStacked.css";
import Helper from "../../../../components/myPortfolios/cards/helper/Helper";

class NewStacked extends Component {
  state = {
    color: d3.scale.ordinal().range(["#4c6ead52", "#81efde33"]),
  };

  componentDidMount() {
    this.drawChart(this.props);
  }

  componentWillReceiveProps(newProps) {
    if (
      // JSON.stringify(this.props.Data1) !== JSON.stringify(props.Data1) ||
      JSON.stringify(this.props.Data2) !== JSON.stringify(newProps.Data2) ||
      this.props.width !== newProps.width
    ) {
      this.drawChart(newProps);
    }
  }

  drawChart = ({ width, height, chartId, Data2, Data1 }) => {
    const { color } = this.state;
    const w = width + 2;
    d3.selectAll(`.${chartId}svg_stack`).remove();

    const x = d3.time.scale().range([0, w]);
    const y = d3.scale.linear().range([height, 0]);

    const stack2 = d3.layout
      .stack()
      .offset("zero")
      .values((d) => d.values)
      .x((d) => d.date)
      .y((d) => d.value);

    const area = d3.svg
      .area()
      .interpolate("cardinal")
      .x((d) => x(d.date))
      .y0((d) => y(d.y0))
      .y1((d) => y(d.y0 + d.y));

    Data1.forEach(function (d) {
      d.value = +d.value;
      d.date = d.date;
    });

    const nest = d3.nest().key((d) => d.key);
    const layers = stack2(nest.entries(Data1));

    x.domain(d3.extent(Data1, (d) => d.date));
    y.domain([0, d3.max(Data1, (d) => d.y0 + d.y)]);

    const svg = d3
      .select(`#${chartId}`)
      .append("svg")
      .attr("width", w)
      .attr("height", height)
      .attr("class", `${chartId}svg_stack`)
      .append("g");

    const browser = svg
      .selectAll(".browser")
      .data(layers)
      .enter()
      .append("g")
      .attr("class", "browser");

    this.path_svg([browser, area, color]);

    // Tooltip
    const pathLine = svg
      .append("g")
      .attr("class", "pathLine")
      .style("display", "none");

    pathLine
      .append("path") // vertical line to follow mouse
      .attr("id", `focus-path-${chartId}`)
      .style("stroke", "#aaa")
      .style("stroke-width", "1px");

    const tooltipHolder = svg
      .append("g")
      .attr("class", "tooltipHolder")
      .style("display", "none");

    this.toolTip_svg([svg, chartId, tooltipHolder]);

    svg
      .append("rect")
      .attr("class", "overlay")
      .attr("width", w)
      .attr("height", height)
      .on("mouseover", function () {
        pathLine.style("display", null);
        tooltipHolder.style("display", null);
      })
      .on("mouseout", function () {
        pathLine.style("display", "none");
        tooltipHolder.style("display", "none");
      })
      .on("mousemove", mousemove);

    function mousemove() {
      const mouse = d3.mouse(this);
      const bisectDate = d3.bisector((d) => d.date).left;

      const x0 = x.invert(mouse[0]),
        i = bisectDate(Data2, x0, 1),
        d0 = Data2[i - 1],
        d1 = Data2[i],
        d = x0 - d0.date > d1.date - x0 ? d1 : d0;

      const depl = parseFloat(d["Benchmark"]);
      const depl2 = parseFloat(d["Portfolio"]);

      let xTransform = x(d.date) >= w / 1.5 ? x(d.date - 3.5) : x(d.date);

      pathLine.attr("transform", "translate(" + x(d.date) + "," + 0 + ")");
      tooltipHolder.attr(
        "transform",
        "translate(" + xTransform + "," + 0 + ")"
      );

      let sup =
        d.date === 1 ? "st" : d.date === 2 ? "nd" : d.date === 3 ? "rd" : "th";

      d3.select(`#text-one-${chartId}`).text(d.date + sup + " " + "YEAR");
      d3.select(`#text-two-${chartId}`).text(
        // "● B* : " + d3.round(depl, 2) + "K"
        "● B* : " + Helper.moneyFormat({ number: depl })
      );
      d3.select(`#text-three-${chartId}`).text(
        // "● P : " + d3.round(depl2, 2) + "K"
        "● P : " + Helper.moneyFormat({ number: depl2 })
      );

      d3.select(`#focus-path-${chartId}`).attr("d", function () {
        let d = "M" + i + "," + height;
        d += " " + i + "," + 40;
        return d;
      });
    }
  };

  path_svg = (props) => {
    var browser = props[0],
      area = props[1],
      color = props[2];
    browser
      .append("path")
      .attr("class", "area")
      .attr("d", (d) => area(d.values))
      .style("fill", (d, i) => color(i));
    // .attr("stroke", "#cfd5e3")
    // .attr("stroke-width", "0.75px");
  };

  toolTip_svg = (props) => {
    var svg = props[0],
      chartId = props[1],
      tooltipHolder = props[2];
    svg.append("g").attr("class", "tooltipHolder").style("display", "none");

    tooltipHolder
      .append("rect")
      .attr("y", 27)
      .attr("width", 90)
      .attr("height", 55)
      .style("fill", "#000000db");

    tooltipHolder
      .append("text")
      .attr("id", `text-one-${chartId}`)
      .attr("x", 10)
      .attr("y", 35)
      .attr("dy", ".35em")
      .style("font-size", 12)
      .style("fill", "#fff");

    tooltipHolder
      .append("text")
      .attr("id", `text-two-${chartId}`)
      .attr("x", 10)
      .attr("y", 50)
      .attr("dy", ".35em")
      .style("font-size", 12)
      .style("fill", "#6d9cf3");

    tooltipHolder
      .append("text")
      .attr("id", `text-three-${chartId}`)
      .attr("x", 10)
      .attr("y", 65)
      .attr("dy", ".35em")
      .style("font-size", 12)
      .style("fill", "#81efde");
  };

  render() {
    return (
      <div
        id={this.props.chartId}
        style={{
          position: "absolute",
          zIndex: "0",
          bottom: "-5px",
          width: "100%",
        }}
      />
    );
  }
}

let d1_type = PropTypes.shape({
  date: PropTypes.number.isRequired,
  key: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string | PropTypes.number]),
});
let d2_type = PropTypes.shape({
  Benchmark: PropTypes.number.isRequired,
  Portfolio: PropTypes.number.isRequired,
  date: PropTypes.number.isRequired,
});
NewStacked.propTypes = {
  width: PropTypes.number.isRequired,
  height: PropTypes.number.isRequired,
  chartId: PropTypes.string.isRequired,
  Data1: PropTypes.arrayOf(d1_type),
  Data2: PropTypes.arrayOf(d2_type),
};
export default NewStacked;



// WEBPACK FOOTER //
// ./src/components/d3Components/StackedArea/NewStackedArea/newStacked.js